<div
  class="
    matrix-card
    tw-w-full
    tw-flex
    tw-flex-col
    tw-mt-[50px]
  "
  data-cy="pool-data-section"
>
  <!-- "Pool Data" pill header (matches the design) -->
  <div
    class="
      matrix-tab-pill
      tw-relative
      tw-bottom-[-11px]
      tw-z-[-1]
      tw-capitalize
      tw-w-[137px]
      tw-bg-[#769ED1]
      tw-text-center
      tw-text-[18px]
      tw-text-[#FFFFFF]
      tw-rounded-[4px]
      tw-pt-[5px]
      tw-pb-[12px]
      tw-px-[5px]
    "
    data-cy="matrix_title"
  >
    {{ 'ui.wager.pool.data' | translate: 'Pool Data' }}
  </div>

  <!-- Selection-change skeleton — masks the tabs + tables briefly
       while the store clears old data and fetches fresh values. -->
  <div
    *ngIf="showSelectionSkeleton"
    class="
      matrix-body matrix-skeleton
      tw-bg-[#EDF1F5]
      tw-rounded-[13px]
      tw-p-[12px]
      tw-pt-[18px]
    "
    aria-hidden="true"
    data-cy="matrix-selection-skeleton"
  >
    <div class="tw-flex tw-gap-[8px] tw-flex-nowrap tw-mb-[14px]">
      <div class="matrix-skeleton__bar tw-h-[26px] tw-w-[70px] tw-rounded-[4px]"></div>
      <div class="matrix-skeleton__bar tw-h-[26px] tw-w-[70px] tw-rounded-[4px]"></div>
      <div class="matrix-skeleton__bar tw-h-[26px] tw-w-[70px] tw-rounded-[4px]"></div>
      <div class="matrix-skeleton__bar tw-h-[26px] tw-w-[70px] tw-rounded-[4px]"></div>
    </div>
    <div class="matrix-skeleton__bar tw-h-[22px] tw-w-full tw-rounded-[4px] tw-mb-[10px]"></div>
    <div class="matrix-skeleton__bar tw-h-[22px] tw-w-full tw-rounded-[4px] tw-mb-[10px]"></div>
    <div class="matrix-skeleton__bar tw-h-[22px] tw-w-full tw-rounded-[4px] tw-mb-[10px]"></div>
    <div class="matrix-skeleton__bar tw-h-[22px] tw-w-full tw-rounded-[4px] tw-mb-[10px]"></div>
    <div class="matrix-skeleton__bar tw-h-[22px] tw-w-[80%] tw-rounded-[4px]"></div>
  </div>

  <!-- Body: tabs + tab content -->
  <div
    *ngIf="!showSelectionSkeleton"
    class="
      matrix-body
      tw-bg-[#EDF1F5]
      tw-rounded-[13px]
      tw-p-[12px]
      tw-pt-[18px]
    "
  >
    <!-- Tab strip
         Mirrors the "Saved / Active / Closed" filter chip row from the
         My Bets card so the two panels feel visually cohesive: dark
         navy pill when inactive, muted grey pill when active. The
         matrix can surface up to eight tabs (Odds / Totals / EX / QU /
         DBL / WillPays / Win Chart / Win Table) depending on the pool
         list — the outer wrapper is `overflow-x: auto` and the inner
         flex row is `flex-nowrap`, so any tabs that don't fit trigger
         a slim themed horizontal scrollbar (see the `.matrix-tabs`
         block in `matrix.component.scss`) instead of wrapping to a
         second row. `flex-shrink: 0` on the pills lives in the same
         SCSS block, keyed off `.matrix-filter-chip`. -->
    <div
      class="matrix-tabs tw-w-full tw-overflow-x-auto tw-pb-[6px]"
      role="tablist"
    >
      <div class="tw-flex tw-gap-[8px] tw-flex-nowrap">
        <button
          type="button"
          (click)="selectTabMenu(ODDS)"
          [class.tw-bg-[#C7C7C6]]="tab === ODDS"
          class="
            matrix-filter-chip
            tw-bg-[#19385D]
            tw-font-normal
            tw-text-[#FFFFFF]
            tw-text-[18px]
            tw-px-[12px]
            tw-py-[4px]
            tw-rounded-[4px]
            tw-cursor-pointer
          "
          data-cy="matrix_odds_tab"
          role="tab"
          [attr.aria-selected]="tab === ODDS"
        >
          {{ 'generic.odds' | translate: 'Odds' }}
        </button>

        <button
          type="button"
          (click)="selectTabMenu(TOTALS)"
          [class.tw-bg-[#C7C7C6]]="tab === TOTALS"
          class="
            matrix-filter-chip
            tw-bg-[#19385D]
            tw-font-normal
            tw-text-[#FFFFFF]
            tw-text-[18px]
            tw-px-[12px]
            tw-py-[4px]
            tw-rounded-[4px]
            tw-cursor-pointer
          "
          data-cy="matrix_totals_tab"
          role="tab"
          [attr.aria-selected]="tab === TOTALS"
        >
          {{ 'generic.totals' | translate: 'Totals' }}
        </button>

        <button
          type="button"
          *ngIf="poolList.includes(EX)"
          (click)="selectTabMenu(EX)"
          [class.tw-bg-[#C7C7C6]]="tab === EX"
          class="
            matrix-filter-chip
            tw-bg-[#19385D]
            tw-font-normal
            tw-text-[#FFFFFF]
            tw-text-[18px]
            tw-px-[12px]
            tw-py-[4px]
            tw-rounded-[4px]
            tw-cursor-pointer
          "
          data-cy="matrix_ex_tab"
          role="tab"
          [attr.aria-selected]="tab === EX"
        >
          {{ 'EX' | translate: 'EX' }}
        </button>

        <button
          type="button"
          *ngIf="poolList.includes(QU)"
          (click)="selectTabMenu(QU)"
          [class.tw-bg-[#C7C7C6]]="tab === QU"
          class="
            matrix-filter-chip
            tw-bg-[#19385D]
            tw-font-normal
            tw-text-[#FFFFFF]
            tw-text-[18px]
            tw-px-[12px]
            tw-py-[4px]
            tw-rounded-[4px]
            tw-cursor-pointer
          "
          data-cy="matrix_qu_tab"
          role="tab"
          [attr.aria-selected]="tab === QU"
        >
          {{ 'QU' | translate: 'QU' }}
        </button>

        <button
          type="button"
          *ngIf="poolList.includes(DBL)"
          (click)="selectTabMenu(DBL)"
          [class.tw-bg-[#C7C7C6]]="tab === DBL"
          class="
            matrix-filter-chip
            tw-bg-[#19385D]
            tw-font-normal
            tw-text-[#FFFFFF]
            tw-text-[18px]
            tw-px-[12px]
            tw-py-[4px]
            tw-rounded-[4px]
            tw-cursor-pointer
          "
          data-cy="matrix_dbl_tab"
          role="tab"
          [attr.aria-selected]="tab === DBL"
        >
          {{ 'DBL' | translate: 'DBL' }}
        </button>

        <button
          type="button"
          (click)="selectTabMenu(WILL_PAYS)"
          [class.tw-bg-[#C7C7C6]]="tab === WILL_PAYS"
          class="
            matrix-filter-chip
            tw-bg-[#19385D]
            tw-font-normal
            tw-text-[#FFFFFF]
            tw-text-[18px]
            tw-px-[12px]
            tw-py-[4px]
            tw-rounded-[4px]
            tw-cursor-pointer
          "
          data-cy="matrix_willpays_tab"
          role="tab"
          [attr.aria-selected]="tab === WILL_PAYS"
        >
          {{ 'generic.willpays' | translate: 'WillPays' }}
        </button>

        <!--
          Video chip: replay on the results page (finished races),
          live video elsewhere. Gate was previously live-only.
        -->
        <button
          type="button"
          (click)="playVideo()"
          [class.tw-opacity-30]="!isVideoAllowed()"
          [class.tw-pointer-events-none]="!isVideoAllowed()"
          class="
            matrix-filter-chip
            tw-bg-[#19385D]
            tw-font-normal
            tw-text-[#FFFFFF]
            tw-text-[18px]
            tw-px-[12px]
            tw-py-[4px]
            tw-rounded-[4px]
            tw-cursor-pointer
          "
          data-cy="matrix_video_tab"
          role="tab"
        >
          {{ 'generic.video' | translate: 'Video' }}
        </button>

        <button
          type="button"
          (click)="selectTabMenu(WIN_CHART)"
          [class.tw-bg-[#C7C7C6]]="tab === WIN_CHART"
          class="
            matrix-filter-chip
            tw-bg-[#19385D]
            tw-font-normal
            tw-text-[#FFFFFF]
            tw-text-[18px]
            tw-px-[12px]
            tw-py-[4px]
            tw-rounded-[4px]
            tw-cursor-pointer
          "
          data-cy="matrix_winchart_tab"
          role="tab"
          [attr.aria-selected]="tab === WIN_CHART"
        >
          {{ 'generic.winchart' | translate: 'Win Chart' }}
        </button>

        <button
          type="button"
          (click)="selectTabMenu(WIN_TABLE)"
          [class.tw-bg-[#C7C7C6]]="tab === WIN_TABLE"
          class="
            matrix-filter-chip
            tw-bg-[#19385D]
            tw-font-normal
            tw-text-[#FFFFFF]
            tw-text-[18px]
            tw-px-[12px]
            tw-py-[4px]
            tw-rounded-[4px]
            tw-cursor-pointer
          "
          data-cy="matrix_wintable_tab"
          role="tab"
          [attr.aria-selected]="tab === WIN_TABLE"
        >
          {{ 'generic.wintable' | translate: 'Win Table' }}
        </button>
      </div>
    </div>

    <!-- Tab content
         Overflow is handled in `matrix.component.scss` (both axes +
         themed scrollbars matching the My Bets card) so that a tab
         with lots of runners or a wide matrix scrolls inside the
         card instead of pushing the surrounding wager page around. -->
    <div class="matrix-tab-content tw-text-sm">
      <ng-container *ngIf="tab === ODDS" [ngTemplateOutlet]="oddsTemplate"></ng-container>
      <ng-container *ngIf="tab === TOTALS" [ngTemplateOutlet]="totalsTemplate"></ng-container>
      <ng-container *ngIf="tab === EX" [ngTemplateOutlet]="exTemplate"></ng-container>
      <ng-container *ngIf="tab === QU" [ngTemplateOutlet]="quTemplate"></ng-container>
      <ng-container *ngIf="tab === DBL" [ngTemplateOutlet]="dblTemplate"></ng-container>
      <ng-container *ngIf="tab === WILL_PAYS" [ngTemplateOutlet]="willPaysTemplate"></ng-container>
      <ng-container *ngIf="tab === WIN_CHART" [ngTemplateOutlet]="winChartTemplate"></ng-container>
      <ng-container *ngIf="tab === WIN_TABLE" [ngTemplateOutlet]="winTableTemplate"></ng-container>
    </div>
  </div>
</div>


<ng-template #oddsTemplate>
  <div
    *ngIf="matrix?.[TRU] || matrix?.[WIN] || matrix?.[PLC] || matrix?.[SHW]"
    class="table-odds tw-w-full"
    data-cy="odds_table"
  >
    <table>
      <thead class="tw-bg-[#D8E8FD]">
        <tr>
          <th></th>
          <th colspan="2" class="!tw-p-0">
            <span class="tw-font-bold tw-items-center tw-w-full">
              <span
                class="odds-th-odds tw-flex tw-justify-center tw-w-full"
                data-cy="odds_table_header"
              >
                {{ 'generic.odds' | translate: 'ODDS' }}
              </span>
              <span class="tru-win tw-flex tw-justify-around tw-w-full tw-text-[12px] !tw-py-[5px]">
                <span data-cy="tru_odds_table">{{ 'ui.wager.tru' | translate: 'TRU' }}</span>
                <span data-cy="win_odds_table">{{ 'WIN' | translate: 'WIN' }}</span>
              </span>
            </span>
          </th>
          <th>
            <span class="odds-th" data-cy="win_table_header">
              <span>$</span>
              <span>{{ 'WIN' | translate: 'WIN' }}</span>
            </span>
          </th>
          <th>
            <span class="odds-th" data-cy="win_percent_table">%</span>
          </th>
          <th>
            <span class="odds-th" data-cy="plc_table_header">
              <span>$</span>
              <span>{{ 'PLC' | translate: 'PLC' }}</span>
            </span>
          </th>
          <th>
            <span class="odds-th" data-cy="plc_percent_table">%</span>
          </th>
          <th>
            <span class="odds-th" data-cy="shw_table_header">
              <span>$</span>
              <span>{{ 'SHW' | translate: 'SHW' }}</span>
            </span>
          </th>
          <th>
            <span class="odds-th" data-cy="shw_percent_table">%</span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let runner of runners; index as i" [attr.data-cy]="'runner-row-' + i">
          <th>
            <span class="tw-font-bold odds-th-left" [attr.data-cy]="'runner-id-' + i">
              {{ runner?.RunnerId || '-' }}
            </span>
          </th>
          <td>
            <span [attr.data-cy]="'tru-odd-' + i">
              {{ ((matrix?.[TRU] || null) | matrixData: i: 'odd') }}
            </span>
          </td>
          <td>
            <span [attr.data-cy]="'win-odd-' + i">
              {{ ((matrix?.[WIN] || null) | matrixData: i: 'odd') }}
            </span>
          </td>
          <!-- WIN -->
          <td>
            <span [attr.data-cy]="'win-number-' + i">
              {{ ((matrix?.[WIN] || null) | matrixData: i) | numberWithCommas: 0 }}
            </span>
          </td>
          <td>
            <span [attr.data-cy]="'win-percent-' + i">
              {{ ((matrix?.[WIN] || null) | matrixData: i: 'percent') }}
            </span>
          </td>
          <!-- PLC -->
          <td>
            <span [attr.data-cy]="'plc-number-' + i">
              {{ ((matrix?.[PLC] || null) | matrixData: i) | numberWithCommas: 0 }}
            </span>
          </td>
          <td>
            <span [attr.data-cy]="'plc-percent-' + i">
              {{ ((matrix?.[PLC] || null) | matrixData: i: 'percent') }}
            </span>
          </td>
          <!-- SHW -->
          <td>
            <span [attr.data-cy]="'shw-number-' + i">
              {{ ((matrix?.[SHW] || null) | matrixData: i) | numberWithCommas: 0 }}
            </span>
          </td>
          <td>
            <span [attr.data-cy]="'shw-percent-' + i">
              {{ ((matrix?.[SHW] || null) | matrixData: i: 'percent') }}
            </span>
          </td>
        </tr>
      </tbody>
      <tfoot class="tw-bg-[#D8E8FD] tw-font-bold">
        <tr>
          <td colspan="3" class="tw-text-center">
            <span data-cy="odds_totals">{{ 'generic.totals' | translate: 'TOTALS' }}</span>
          </td>
          <td>
            <span data-cy="win_totals">
              {{ (matrix?.[WIN]?.Total | numberWithCommas: 0) || '-' }}
            </span>
          </td>
          <td></td>
          <td>
            <span data-cy="plc_totals">
              {{ (matrix?.[PLC]?.Total | numberWithCommas: 0) || '-' }}
            </span>
          </td>
          <td></td>
          <td>
            <span data-cy="shw_totals">
              {{ (matrix?.[SHW]?.Total | numberWithCommas: 0) || '-' }}
            </span>
          </td>
          <td></td>
        </tr>
      </tfoot>
    </table>
  </div>

  <div *ngIf="!(matrix?.[TRU] || matrix?.[WIN] || matrix?.[PLC] || matrix?.[SHW])">
    <span class="tw-flex tw-p-4">
      {{ 'ui.wager.no.odds.at.this.moment' | translate: 'No Odds at this Moment' }}
    </span>
  </div>
</ng-template>


<ng-template #totalsTemplate>
  <div *ngIf="
    (singleLegDict && (singleLegDict|json) !== '{}')
    || (singleLegDict?.[WIN] && (singleLegDict?.[WIN]|json) !== '{}')
    || (singleLegDict?.[PLC] && (singleLegDict?.[PLC]|json) !== '{}')
    || (singleLegDict?.[SHW] && (singleLegDict?.[SHW]|json) !== '{}')
    || (matrix?.[WIN] && (matrix?.[WIN]|json) !== '{}')
    || (matrix?.[PLC] && (matrix?.[PLC]|json) !== '{}')
    || (matrix?.[SHW] && (matrix?.[SHW]|json) !== '{}')
    || (multiLegDict && (multiLegDict|json) !== '{}')
    || (multiRaceDict && (multiRaceDict|json) !== '{}')
  ">
    <div class="table-totals">
      <table>
        <thead>
          <tr>
            <th>{{ 'generic.runner' | translate: 'Runner' }}</th>
            <th class="totals-th">
              WIN
              {{
                '(' + (((singleLegDict?.[WIN]?.TakeoutRates || 0) * 100) | numberWithCommas) + '%)'
              }}
            </th>
            <th class="totals-th">
              PLC
              {{
                '(' + (((singleLegDict?.[PLC]?.TakeoutRates || 0) * 100) | numberWithCommas) + '%)'
              }}
            </th>
            <th class="totals-th">
              SHW
              {{
                '(' + (((singleLegDict?.[SHW]?.TakeoutRates || 0) * 100) | numberWithCommas) + '%)'
              }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let runner of runners; index as i">
            <th>{{ runner?.RunnerId || '-' }}</th>
            <td>
              <span>
                {{ ((matrix?.[WIN] || null) | matrixData: i) | numberWithCommas: 0 }}
              </span>
            </td>
            <td>
              <span>
                {{ ((matrix?.[PLC] || null) | matrixData: i) | numberWithCommas: 0 }}
              </span>
            </td>
            <td>
              <span>
                {{ ((matrix?.[SHW] || null) | matrixData: i) | numberWithCommas: 0 }}
              </span>
            </td>
          </tr>
        </tbody>
        <tfoot class="tw-bg-[#D8E8FD]">
          <tr>
            <td class="tw-font-bold">
              <span>{{ 'generic.totals' | translate: 'Totals' }}</span>
            </td>
            <td>
              <span>
                {{ (matrix?.[WIN]?.Total | numberWithCommas: 0) || '-' }}
              </span>
            </td>
            <td>
              <span>
                {{ (matrix?.[PLC]?.Total | numberWithCommas: 0) || '-' }}
              </span>
            </td>
            <td>
              <span>
                {{ (matrix?.[SHW]?.Total | numberWithCommas: 0) || '-' }}
              </span>
            </td>
          </tr>
        </tfoot>
      </table>

      <table>
        <thead>
          <tr>
            <th colspan="2">{{ 'ui.wager.multi.position' | translate: 'Multi Position' }}</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngIf="multiLegDict && (multiLegDict|json) !== '{}'">
            <tr *ngFor="let item of multiLegDict | keyvalue">
              <th class="totals-th">
                {{
                  item.key + ' (' +
                  ((((item.value | toAny)?.TakeoutRates || 0) * 100) | numberWithCommas) + '%)'
                }}
              </th>
              <td>
                <span>
                  {{ (item.value | toAny)?.Total | numberWithCommas: 0 }}
                </span>
              </td>
            </tr>
          </ng-container>

          <ng-container *ngIf="!(multiLegDict && (multiLegDict|json) !== '{}')">
            <tr>
              <td colspan="2">
                <span class="tw-flex tw-p-4">
                  {{ 'ui.wager.no.multi.position.data' | translate: 'No Multi Position Data' }}
                </span>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>

      <table>
        <thead>
          <tr>
            <th colspan="2">{{ 'wager.matrix.multirace' | translate: 'Multi Race' }}</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngIf="multiRaceDict && (multiRaceDict|json) !== '{}'">
            <tr *ngFor="let item of multiRaceDict | keyvalue">
              <th class="totals-th">
                {{ item.key + ' (' +
                ((((item.value | toAny)?.TakeoutRates || 0) * 100) | numberWithCommas) + '%)' }}
              </th>
              <td>
                <span>
                  {{ (item.value | toAny)?.Total | numberWithCommas: 0 }}
                </span>
              </td>
            </tr>
          </ng-container>

          <ng-container *ngIf="!(multiRaceDict && (multiRaceDict|json) !== '{}')">
            <tr>
              <td colspan="2">
                <span class="tw-flex tw-p-4">
                  {{ 'ui.wager.no.multi.race.data' | translate: 'No Multi Race Data' }}
                </span>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>

  <div *ngIf="
    !(
      (singleLegDict && (singleLegDict|json) !== '{}')
      || (singleLegDict?.[WIN] && (singleLegDict?.[WIN]|json) !== '{}')
      || (singleLegDict?.[PLC] && (singleLegDict?.[PLC]|json) !== '{}')
      || (singleLegDict?.[SHW] && (singleLegDict?.[SHW]|json) !== '{}')
      || (matrix?.[WIN] && (matrix?.[WIN]|json) !== '{}')
      || (matrix?.[PLC] && (matrix?.[PLC]|json) !== '{}')
      || (matrix?.[SHW] && (matrix?.[SHW]|json) !== '{}')
      || (multiLegDict && (multiLegDict|json) !== '{}')
      || (multiRaceDict && (multiRaceDict|json) !== '{}')
    )
  ">
    <span class="tw-flex tw-p-4">
      {{ 'ui.wager.no.totals.data' | translate: 'No Totals Data' }}
    </span>
  </div>
</ng-template>


<ng-template #exTemplate>
  <div *ngIf="matrix?.[EX]">
    <p class="tw-py-2 tw-font-bold total-top">
      PT: ${{ matrix[EX]?.Total | numberWithCommas: 0 }}
    </p>
    <div class="tw-block tw-overflow-auto">
      <table class="table-ex">
        <thead>
          <tr>
            <th class="ex-th">1/2</th>
            <th class="ex-th" *ngFor="let col of (matrix[EX]?.NumberOfColumns | convertTRange)">
              {{ col }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of (matrix[EX]?.NumberOfRows | convertTRange); index as i">
            <th class="ex-th">{{ row }}</th>
            <ng-container *ngFor="let col of matrix[EX]?.Rows[i]?.Columns">
              <td [class]="(col?.fairValueClass || '') + ' ' + (col?.favouriteBetClass || '')">
                <span>
                  {{
                    (!col?.data)
                      ? '\u00A0'
                      : (col?.data | numberWithCommas: 0)
                  }}
                </span>
              </td>
            </ng-container>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div *ngIf="!matrix?.[EX]">
    <span class="tw-flex tw-p-4">
      {{
        selectedRace?.Current
        && ((selectedRace?.PostTime || '' | convertTimeToMinutes) < 60)
        && multiLegDict?.[EX]?.Total > 0
          ? ('wager.matrix.notavailable' | translate: 'Matrix not available at this time.')
          : ('ui.wager.matrix.pool.data.note' | translate)
      }}
    </span>
  </div>
</ng-template>


<ng-template #quTemplate>
  <div *ngIf="matrix?.[QU]">
    <p class="tw-py-2 tw-font-bold total-top">
      PT: ${{ matrix[QU]?.Total | numberWithCommas: 0 }}
    </p>
    <div class="tw-block tw-overflow-auto">
      <table class="table-qu">
        <thead>
          <tr>
            <th class="qu-th">1/2</th>
            <th class="qu-th" *ngFor="let col of (matrix[QU]?.NumberOfColumns | convertTRange)">
              {{ col }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of (matrix[QU]?.NumberOfRows | convertTRange); index as i">
            <th class="qu-th">{{ row }}</th>
            <ng-container *ngFor="let col of matrix[QU]?.Rows[i]?.Columns">
              <td [class]="(col?.favouriteBetClass || '')">
                <span>
                  {{
                    (!col?.data)
                      ? '\u00A0'
                      : (col?.data | numberWithCommas: 0)
                  }}
                </span>
              </td>
            </ng-container>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div *ngIf="!matrix?.[QU]">
    <span class="tw-flex tw-p-4">
      {{
        selectedRace?.Current
        && ((selectedRace?.PostTime || '' | convertTimeToMinutes) < 60)
        && multiLegDict?.[QU]?.Total > 0
          ? ('wager.matrix.notavailable' | translate: 'Matrix not available at this time.')
          : ('ui.wager.matrix.pool.data.note' | translate)
      }}
    </span>
  </div>
</ng-template>


<ng-template #dblTemplate>
  <div *ngIf="matrix?.[DBL]">
    <p class="tw-py-2 tw-font-bold total-top">
      PT: ${{ matrix[DBL]?.Total | numberWithCommas: 0 }}
    </p>
    <div class="tw-block tw-overflow-auto">
      <table class="table-dbl">
        <thead>
          <tr>
            <th class="dbl-th">1/2</th>
            <th class="dbl-th" *ngFor="let col of (matrix[DBL]?.NumberOfColumns | convertTRange)">
              {{ col }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of (matrix[DBL]?.NumberOfRows | convertTRange); index as i">
            <th class="dbl-th">{{ row }}</th>
            <ng-container *ngFor="let col of matrix[DBL]?.Rows[i]?.Columns">
              <td [class]="(col?.favouriteBetClass || '')">
                <span>
                  {{
                    (!col?.data)
                      ? '\u00A0'
                      : (col?.data | numberWithCommas: 0)
                  }}
                </span>
              </td>
            </ng-container>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div *ngIf="!matrix?.[DBL]">
    <span class="tw-flex tw-p-4">
      {{
        selectedRace?.Current
        && ((selectedRace?.PostTime || '' | convertTimeToMinutes) < 60)
        && multiLegDict?.[DBL]?.Total > 0
          ? ('wager.matrix.notavailable' | translate: 'Matrix not available at this time.')
          : ('ui.wager.matrix.pool.data.note' | translate)
      }}
    </span>
  </div>
</ng-template>


<ng-template #willPaysTemplate>
  <div *ngIf="willPays?.Pools" class="tw-block tw-overflow-auto">
    <table class="table-willpay">
      <thead>
        <tr>
          <th class="willpay-th"></th>
          <th class="willpay-th" *ngFor="let pool of willPays?.Pools">
            <div class="willpay-th-top">
              <span>
                {{ '$' + pool?.Wager + ' ' + pool?.PoolId }}
              </span>
              <span>
                {{ (pool?.Live | numberWithCommas: 0) }}
              </span>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th class="willpay-th !tw-px-[4px]">{{ 'main.results' | translate: 'Results' }}</th>
          <td *ngFor="let pool of willPays?.Pools">
            <span>
              {{ pool?.Willpays?.[0]?.Finish }}
            </span>
          </td>
        </tr>
        <ng-container *ngFor="let pay of willPays?.Pools?.[0]?.Willpays?.[0]?.Pays; index as i">
          <tr>
            <th
              class="
                willpay-th
                {{ TRACK_TYPE_lIST[selectedRace?.TrackType || 1] + '-' + pay?.RunnerId }}
              "
            >
              {{ pay?.RunnerId }}
            </th>
            <td *ngFor="let pool of willPays?.Pools">
              <span>
                {{ pool?.Willpays?.[0]?.Pays?.[i]?.Price || ' ' | numberWithCommas: 2 }}
              </span>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>

  <div *ngIf="!willPays?.Pools">
    <span class="tw-flex tw-p-4">
      {{
        (selectedRace?.RaceId || 0) > 1
          ? ('wager.matrix.nowillpays' | translate: 'WillPays not available at this time')
          : ('wager.no.willpay' | translate: 'There is no WillPay')
      }}
    </span>
  </div>
</ng-template>


<ng-template #winChartTemplate>
  <div
    *ngIf="winChartHasData && !winChartLoad"
    data-cy="win_chart_panel"
  >
    <div class="win-chart-content tw-overflow-x-auto tw-h-[420px] tw-mb-[1rem]">
      <!--
        CanvasJS renders directly onto this container div. See the
        CanvasJS "Basics" doc for the vanilla HTML5 mounting pattern:
        https://canvasjs.com/docs/charts/basics-of-creating-html5-chart/
        The Angular side of the wiring lives in `matrix.component.ts`
        (`renderWinChart`).
      -->
      <div
        #winChartContainer
        class="win-chart-canvas tw-w-full tw-h-full"
        data-cy="win_chart_canvas"
      ></div>
    </div>

    <div class="win-chart-buttons tw-flex tw-justify-evenly tw-mt-[1rem]">
      <button
        type="button"
        class="win-chart-btn"
        [class.btn-active]="winChartFilterButtons.WIN"
        (click)="winChartFilter('WIN')"
        data-cy="win_chart_btn_win"
      >
        {{ 'WIN' | translate: 'WIN' }}
      </button>
      <button
        type="button"
        class="win-chart-btn"
        [class.btn-active]="winChartFilterButtons.TRU"
        (click)="winChartFilter('TRU')"
        data-cy="win_chart_btn_tru"
      >
        {{ 'ui.wager.tru' | translate: 'TRU' }}
      </button>
      <button
        type="button"
        class="win-chart-btn"
        [class.btn-active]="winChartFilterButtons.BOTH"
        (click)="winChartFilter('BOTH')"
        data-cy="win_chart_btn_both"
      >
        {{ 'ui.wager.both' | translate: 'BOTH' }}
      </button>
    </div>
  </div>

  <div
    *ngIf="winChartLoad"
    class="
      tw-flex
      tw-justify-center
      tw-items-center
      tw-w-full
      tw-h-[420px]
    "
    data-cy="win_chart_loading"
  >
    <mat-spinner [diameter]="50"></mat-spinner>
  </div>

  <ng-container *ngIf="!winChartLoad">
    <div *ngIf="!winChartHasData">
      <span class="tw-flex tw-p-4">
        {{ 'ui.wager.no.odds.at.this.moment' | translate: 'No Odds at this Moment' }}
      </span>
    </div>
  </ng-container>
</ng-template>


<ng-template #winTableTemplate>
  <div *ngIf="winTable && (winTable | json) !== '[]'" data-cy="win_table_panel">
    <table class="table-wintable">
      <thead>
        <tr>
          <th class="wintable-th tw-w-[25px]"></th>
          <th
            class="wintable-th tw-w-0"
            *ngFor="let item of 5 | convertTRange; index as index5"
          >
            {{ winTable?.[index5]?.time || '-' }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let runner of runners; index as indexRunner">
          <th class="wintable-th">
            {{ runner?.RunnerId }}
          </th>
          <td *ngFor="let item of 5 | convertTRange; index as index5">
            <span class="tw-inline-flex tw-items-center">
              {{
                ((winTable?.[index5]?.totals[indexRunner]?.odds || '-')
                  | numberWithCommas: 2)
              }}
              <mat-icon
                *ngIf="winTable?.[index5]?.totals[indexRunner]?.odd_remark"
                class="wintable-arrow"
                [class.up]="winTable?.[index5]?.totals[indexRunner]?.odd_remark === 'decrease'"
                [class.down]="winTable?.[index5]?.totals[indexRunner]?.odd_remark === 'increase'"
              >
                {{
                  winTable?.[index5]?.totals[indexRunner]?.odd_remark === 'increase'
                    ? 'keyboard_arrow_down'
                    : 'keyboard_arrow_up'
                }}
              </mat-icon>
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div *ngIf="!(winTable && (winTable | json) !== '[]')">
    <span class="tw-flex tw-p-4">
      {{ 'ui.wager.no.odds.at.this.moment' | translate: 'No Odds at this Moment' }}
    </span>
  </div>
</ng-template>
